import {
    faTrash,
    faFire,
    faPhoneVolume,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useState } from "react";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/esm/Tooltip";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useUserInfor } from "../../../../Context/User";
import {
    AtualizarContatoTelefoneController,
    DeletarContatoTelefoneController,
} from "../../../../Controllers/Geral/Contatos/ContatoTelefone/ContatoTelefoneController";
import {
    DesligarChamadaController,
    EfetuarDiscagemController,
} from "../../../../Controllers/Geral/Telefonia/TelefoniaController";
import { IContatoTelefone } from "../../../../Interfaces/Geral/Contatos/ContatoTelefone/ContatoTelefoneInterface";
import { formatPhoneTelefonia } from "../../../../Tools/FormatTools";
import { AlertConfirm } from "../../../../Tools/SweetAlerts";
import CopyToClipboard from "../../../Utils/CopyToClipboard";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import WhatsappAtivo, { InforWhatsappSend } from "../../../Utils/WhatsappAtivo";
import ModalComponent from "../../../Modais";
import { IComponentModal } from "../../../Modais/IModalComponent";
import { IContatoComTelefone } from "../../../../Interfaces/Geral/Contatos/ContatosInterfaces";

interface IContatoTelefoneProps {
    contato_tel: IContatoTelefone;
    updateContatos: () => void;
    idCaso: number | undefined;
    showDiscagemButton: "" | "DISCAR" | "DESLIGAR";
    setNumeroEmAtendimento: Dispatch<SetStateAction<string>>;
    lstContatos?: IContatoComTelefone[];
}

export function ContatoTelefone(props: IContatoTelefoneProps) {
    const {
        contato_tel,
        updateContatos,
        showDiscagemButton,
        setNumeroEmAtendimento,
        lstContatos,
    } = props;
    const { bloquearInteracoes } = useAtendimentoPage();
    const { UserInfor } = useUserInfor();

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const StringDDD = contato_tel.COD_DDD ? `(${contato_tel.COD_DDD})` : "";

    const telefoneFormatado = `${
        contato_tel.COD_DDI ? contato_tel.COD_DDI : ""
    } ${StringDDD} ${contato_tel.NR_TELEFONE}`;

    const podeEditar =
        !bloquearInteracoes &&
        UserInfor.FUNCOES.some((f) => f.NM_FUNCAO === "ADM_EDITAR_TELEFONE") &&
        contato_tel.DS_TIPO_TELEFONE !== "UAU";
    const podeDeletar =
        !bloquearInteracoes &&
        UserInfor.FUNCOES.some((f) => f.NM_FUNCAO === "ADM_EXCLUIR_TELEFONE");

    return (
        <div className="py-2">
            <div className="d-flex flex-wrap align-itens-center justify-content-between m-2">
                <div className="d-flex flex-column">
                    <span className="text-dark-75 font-weight-bolder mr-2">
                        {podeDeletar && (
                            <span
                                className="mr-2 text-danger text-hover-info"
                                role="button"
                                onClick={() => {
                                    AlertConfirm(
                                        "Deseja apagar este telefone do contato?"
                                    ).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarContatoTelefoneController({
                                                IDContatoTelefone:
                                                    contato_tel.DS_TIPO_TELEFONE !==
                                                    "UAU"
                                                        ? contato_tel.ID_CONTATO_TELEFONE
                                                        : undefined,
                                                COD_DDD: contato_tel.COD_DDD,
                                                NR_TELEFONE:
                                                    contato_tel.NR_TELEFONE,
                                                ID_CHAVE_ERP:
                                                    contato_tel.DS_TIPO_TELEFONE ===
                                                    "UAU"
                                                        ? String(
                                                              contato_tel.ID_CONTATO_TELEFONE
                                                          )
                                                        : undefined,
                                            }).then(() => {
                                                updateContatos();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </span>
                        )}
                        {podeEditar && (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="hot-number-tooltip">
                                        {contato_tel.FL_HOT_NUMBER
                                            ? "Tirar"
                                            : "Tornar"}{" "}
                                        Hot-Number
                                    </Tooltip>
                                }
                            >
                                <span
                                    className="m-2 text-info text-hover-info"
                                    role="button"
                                    onClick={() => {
                                        AtualizarContatoTelefoneController({
                                            ...contato_tel,
                                            FL_HOT_NUMBER:
                                                !contato_tel.FL_HOT_NUMBER,
                                        }).then(() => {
                                            updateContatos();
                                        });
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFire} />
                                </span>
                            </OverlayTrigger>
                        )}
                        {UserInfor.FUNCOES.some(
                            (f) => f.NM_FUNCAO === "WHATS_MENSAGEM_ATIVA"
                        ) && (
                            <span className="m-2">
                                <WhatsappAtivo
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent: "Enviar mensagem!",
                                            IconHeader: faWhatsapp,
                                            size: "lg",
                                            Component: () => (
                                                <InforWhatsappSend
                                                    lstContatos={[
                                                        `${contato_tel.COD_DDD}${contato_tel.NR_TELEFONE}`,
                                                    ]}
                                                    setModal={setShow}
                                                    lstContatoConta={
                                                        lstContatos
                                                    }
                                                />
                                            ),
                                        });
                                    }}
                                />
                            </span>
                        )}
                        <span className="m-2">
                            <CopyToClipboard>
                                {telefoneFormatado}
                            </CopyToClipboard>
                        </span>
                        {telefoneFormatado}
                    </span>
                    <span>
                        {contato_tel.DS_OBS ? contato_tel.DS_OBS : "Obs: -"}
                    </span>
                </div>

                <div className="d-flex flex-wrap align-items-end flex-column flex-grow-1">
                    {contato_tel.FL_HOT_NUMBER && (
                        <span className="label label-pill label-inline label-success my-1">
                            <FontAwesomeIcon icon={faFire} className="mr-2" />
                            HotNumber
                        </span>
                    )}
                    <span className="label label-pill label-inline label-success my-1">
                        {contato_tel.DS_TIPO_TELEFONE}
                    </span>
                    {contato_tel.FL_UAU && (
                        <span className="label label-pill label-inline label-success my-1">
                            UAU
                        </span>
                    )}
                    {Boolean(
                        !bloquearInteracoes &&
                            UserInfor.NR_AGENTE_DISCADOR &&
                            UserInfor.ID_RAMAL_DISCADOR &&
                            props.idCaso
                    ) && (
                        <>
                            {showDiscagemButton === "DESLIGAR" ? (
                                <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    onClick={() => {
                                        if (
                                            contato_tel.COD_DDD &&
                                            contato_tel.NR_TELEFONE &&
                                            props.idCaso
                                        ) {
                                            DesligarChamadaController(
                                                props.idCaso
                                            ).then(() =>
                                                setNumeroEmAtendimento("")
                                            );
                                        }
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faPhoneVolume}
                                        size="lg"
                                        className="mr-2"
                                    />
                                    Desligar
                                </button>
                            ) : (
                                showDiscagemButton === "DISCAR" && (
                                    <button
                                        type="button"
                                        className="btn btn-outline-success"
                                        onClick={() => {
                                            if (
                                                contato_tel.COD_DDD &&
                                                contato_tel.NR_TELEFONE &&
                                                props.idCaso
                                            ) {
                                                EfetuarDiscagemController(
                                                    formatPhoneTelefonia(
                                                        contato_tel.COD_DDD,
                                                        contato_tel.NR_TELEFONE
                                                    ),
                                                    props.idCaso
                                                ).then(() =>
                                                    setNumeroEmAtendimento(
                                                        `${contato_tel.COD_DDD}${contato_tel.NR_TELEFONE}`
                                                    )
                                                );
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPhoneVolume}
                                            className="mr-2"
                                        />
                                        Discar
                                    </button>
                                )
                            )}
                        </>
                    )}
                </div>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
